import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // Header translations
      header: {
        menuItems: {
          brand: "Brand",
          creator: "Creator",
          pricing: "Pricing",
          aboutUs: "About Us",
        },
        actions: {
          register: "Register",
          backToDashboard: "Back To Dashboard",
          editProfile: "Edit Profile",
          helpCenter: "Help Center",
          logout: "Log Out",
        },
        creatorActions: {
          appliedJobs: "Applied Jobs",
          inProgress: "In Progress",
          myEarnings: "My Earnings",
          mySubscription: "My Subscription",
        },
        brandActions: {
          activeJobs: "Active Jobs",
          myProduct: "My Product",
          creatorSpotlight: "Creator Spotlight",
          transactionHistory: "Transaction History",
        },
      },

      // Footer translations
      footer: {
        intro:
          "Discover the platform that makes collaborations between businesses and content creators easy. Start today and reach your potential with authentic UGC.",
        sections: {
          navigate: "Navigate",
          supportUs: "Support Us",
          contactUs: "Contact Us",
        },
        navigateLinks: {
          home: "Home",
          brand: "Brand",
          creator: "Creator",
          pricing: "Pricing",
          aboutUs: "About Us",
        },
        supportLinks: {
          faqs: "FAQs",
          supportCenter: "Support center",
        },
        contactLinks: {
          email: "collabbarter@.com",
          phone: "+01123 456 7890",
        },
        copyright: "© 2025 Collab Barter, We love our users!",
        termsConditions: "Terms & Conditions",
        privacyPolicy: "Privacy Policy",
      },

      // Hero Section translations
      heroSection: {
        label: "Influencer Marketing Made Easy",
        heading: {
          part1: "Connecting",
          part2: "Creativity",
          part3: "with",
          part4: "Collab barter",
          part5: ".",
        },
        subtitle:
          "Discover the platform that makes collaborations between businesses and content creators easy. Start today and reach your potential with authentic UGC.",
        ctaButtons: {
          brand: "Become a Brand",
          creator: "Become a Creator",
        },
        stats: {
          creators: "63,000 Creators",
          building: "is building collab barter together",
        },
        brandStats: {
          count: "5000+ BRANDS",
        },
        creatorStats: {
          count: "10k+",
          text: "Creator",
        },
      },

      // Teamup Section translations
      teamupSection: {
        heading: {
          part1: "Team up",
          part2: "with top tier",
          part3: "brands",
          part4: "and",
          part5: "companies.",
        },
        brands: {
          thuisbezorgd: "Thuisbezorgd.nl",
          sushito: "Sushito",
          flink: "Flink",
        },
      },

      // Policy Section translations
      policySection: {
        heading: {
          part1: "Effortless",
          part2: "work,",
          part3: "powerful",
          part4: "results.",
        },
        subtitle:
          "The Barter platform connects you with the right content creators to reach new customers, whether you're running a restaurant, workshop, bar, brand or clothing store.",
        features: [
          {
            title: "Over 5,000 trusted and verified content creators.",
            description:
              "Our verified content creators connect with your audience through quality and impactful content.",
          },
          {
            title: "Effortless collaboration made simple and fast.",
            description:
              "Reasonable content creation join your deal and you get a preview after represents your brand.",
          },
          {
            title: "Say goodbye to payments start bartering instead!",
            description:
              "Unlock the potential of your product strategy to boost your first few never before.",
          },
          {
            title: "Genuine and Lasting Brand Impact",
            description:
              "Experience immediate growth through the people you work with. Authentic UGC.",
          },
        ],
      },

      // Brand Section translations
      brandSection: {
        heading: {
          part1: "Brands: ",
          part2: "5,000+ ",
          part3: "creators are ready for ",
          part4: "you on our app.",
        },
        description:
          "Our user-friendly platform lets you create UGC without agencies or long-term commitments. Content creators connect with you through our app—just pick your favorites!",
        ctaButton: "Become a Brand",
        cards: {
          firstBrand: "Thuisbezorgd.nl",
          secondBrand: "Sushito",
        },
      },

      // Content Section translations
      contentSection: {
        heading: {
          part1: "Genuine content tailored",
          part2: "specifically for you.",
        },
        subtitle:
          "The Barter platform connects you with the right content creators to reach new customers, whether you're running a restaurant, webshop, bar, brand or clothing store.",
      },

      // Subscription Plans translations
      subscriptionPlans: {
        heading: {
          part1: "Inspiring possibility and applying",
          part2: "innovation",
        },
        subtitle: "Started today. We're ready!",
        popular: "Most popular",
        chooseButton: "Choose Plan",
        plans: [
          {
            price: "15",
            period: "Monthly Plan",
            features: [
              "Unlimited campaign applications",
              "Premium badge on profile",
              "Priority in search results",
              "Basic performance analytics (views, clicks, likes per campaign)",
              "Early access to new campaigns (48 hours earlier)",
              "Faster profile approval",
            ],
          },
          {
            price: "15",
            period: "Yearly Plan",
            features: [
              "Reduced commission: 10% instead of 15%",
              "1x Profile Spotlight per year (profile featured for 7 days in Explore)",
              "Monthly and per-campaign performance statistics",
              "Priority support (direct access to help team)",
              "Bonus Feature: Campaign Favorites",
            ],
          },
          {
            price: "120",
            period: "Quarterly Plan",
            features: [
              "Unlimited campaign applications",
              "Premium badge on profile",
              "Priority in search results",
              "Basic performance analytics (views, clicks, likes per campaign)",
              "Early access to new campaigns (48 hours earlier)",
              "Faster profile approval",
              "1 exclusive invite-only campaign per quarter",
            ],
          },
        ],
      },

      // Our Mission Section translations
      ourMission: {
        heading: "We empower your brand to thrive and grow.",
        description:
          "Our mission is to make influencer and creator marketing accessible to businesses of all sizes, driving your growth. Harness the value of your own product and eliminate advertising expenses.",
        ctaButton: "Try to free",
      },

      // Register Type Page translations
      registerType: {
        pageTitle: "Registration",
        brand: {
          title: "For Brands & Agencies",
          description:
            "Create orders for your products or services and let creators promote them for you.",
          button: "Register as Brand or Agency",
        },
        creator: {
          title: "For Creators",
          description:
            "Sign up to apply for projects, create product content, and get paid.",
          button: "Register as Creator",
        },
      },

      // Creator Registration Form translations
      creatorRegister: {
        title: "Creator registration",
        googleButton: "Continue with Google",
        or: "Or",
        fields: {
          firstName: {
            label: "First name",
            placeholder: "Enter first name",
            error: {
              required: "*First name is required",
              minLength: "*Must be at least 3 characters",
              maxLength: "*Must be at most 50 characters",
            },
          },
          lastName: {
            label: "Last name",
            placeholder: "Enter last name",
            error: {
              required: "*Last name is required",
              minLength: "*Must be at least 3 characters",
              maxLength: "*Must be at most 50 characters",
            },
          },
          email: {
            label: "Email",
            placeholder: "Enter your email",
            error: {
              required: "*Email is required",
              invalid: "*Enter a valid email",
              minLength: "*Must be at least 5 characters",
              maxLength: "*Must be at most 254 characters",
            },
          },
          dateOfBirth: {
            label: "Date of birth",
            placeholder: "DD/MM/YYYY",
            error: {
              required: "*Date of birth is required",
              future: "*Date cannot be in the future",
            },
          },
        },
        terms: {
          text: "By creating an account or signing in, you agree to our",
          termsLink: "Terms of Service",
          and: "and",
          privacyLink: "Privacy Policy",
          error: "*You must accept the terms and conditions",
        },
        buttons: {
          signUp: "Sign Up",
        },
      },

      // Brand Registration Form translations
      brandRegister: {
        title: "Register as a brand",
        editTitle: "Edit your info",
        description:
          "Build your brand presence. Enter your details to get started.",
        editDescription:
          "Update your personal information to keep your profile current.",
        fields: {
          fullName: {
            label: "Full name",
            placeholder: "Enter full name",
            error: {
              required: "*Full name is required",
              minLength: "*Must be at least 3 characters",
              maxLength: "*Must be at most 100 characters",
            },
          },
          email: {
            label: "Email",
            placeholder: "Enter your email",
            error: {
              required: "*Email is required",
              invalid: "*Enter a valid email",
              minLength: "*Must be at least 5 characters",
              maxLength: "*Must be at most 254 characters",
            },
          },
        },
        terms: {
          text: "I have read the",
          privacyLink: "data protection regulations",
          and: "&",
          termsLink: "terms and conditions",
          agree: "and agree to them.",
          error: "*You must accept the terms and conditions",
        },
        buttons: {
          next: "Next",
          save: "Save",
        },
      },

      // BrandInfoForm translations
      brandForm: {
        title: {
          register: "Register as a brand",
          edit: "Edit your brand",
        },
        subtitle: {
          register:
            "Your gateway to the world of creativity and collaboration! Let's dive into the magic of filmmaking together!",
          edit: "Update your brand information to keep your profile current and accurate.",
        },
        fields: {
          brandName: {
            label: "Name of your brand",
            placeholder: "Enter your brand name",
          },
          website: {
            label: "Your brand's website",
            placeholder: "www.brandwebsite.com (Optional)",
          },
          category: {
            label: "Industry / category",
            placeholder: "Select industry/category",
          },
          taxId: {
            label: "Tax ID",
            placeholder: "Enter tax ID (Optional)",
          },
          isAgency: "My company is an agency",
        },
        buttons: {
          register: "Sign Up",
          save: "Save",
        },
        errors: {
          brandNameRequired: "*Brand name is required",
          brandNameLength: "*Must be between 3-100 characters",
          websiteLength: "*Must be between 3-300 characters",
          categoryRequired: "*At least one industry/category is required",
          taxIdLength: "*Must be between 4-25 characters",
        },
      },

      // Verification Form translations
      verification: {
        title: "Verify your email",
        sentCode:
          "We've sent a code to {{email}}. Enter it here to confirm your account.",
        edit: "EDIT",
        enterOtp: "Enter OTP",
        notReceived: "Haven't received the OTP?",
        resend: "Resend",
        sending: "Sending...",
        signIn: "Sign In",
        errors: {
          emailNotFound: "Email not found. Please go back and register again.",
          resendFailed: "Failed to resend OTP",
          somethingWrong: "Something went wrong. Please try again.",
          verificationFailed: "Verification failed. Please try again.",
          otpValidation: "*Please enter a valid 6-digit OTP",
          otpRequired: "*OTP is required",
        },
      },

      // Register Dialog translations
      registerDialog: {
        title: "Hey, Welcome back!",
        subtitle: "Sign in to continue your journey.",
        continueWithGoogle: "Continue with Google",
        dividerText: "Or",
        emailLabel: "Email",
        termsText: "By creating an account or signing in, you agree to our",
        termsLink: "Terms of Service",
        andText: "and",
        privacyLink: "Privacy Policy",
        submitButton: "Sign In",
        errorMessages: {
          emailRequired: "*Email is required",
          emailValid: "*Enter a valid email",
          emailMinLength: "*Must be at least 5 characters",
          emailMaxLength: "*Must be at most 254 characters",
          termsAccepted: "*You must accept the terms and conditions",
        },
      },

      // Verification Dialog translations
      verificationDialog: {
        title: "Verify your email",
        subtitle: "We've sent a verification code to",
        editButton: "EDIT",
        otpLabel: "Enter OTP",
        notReceivedText: "Haven't received the OTP?",
        resendButton: "Resend",
        sendingText: "Sending...",
        submitButton: "Sign In",
        errorMessages: {
          otpRequired: "*OTP is required",
          otpValid: "*Please enter a valid 6-digit OTP",
          verificationFailed: "Verification failed. Please try again.",
          emailNotFound: "Email not found. Please go back and register again.",
          resendFailed: "Failed to resend OTP",
          defaultError: "Something went wrong. Please try again.",
        },
      },

      // HelpCenter translations
      helpCenter: {
        title: "Help Center",
        fields: {
          email: "Email",
          reason: "Select reason",
          message: "Message",
        },
        placeholders: {
          email: "Enter your email",
          reason: "Select your reason",
          message: "Write your message here...",
        },
        validation: {
          validEmail: "*Enter a valid email",
          minEmail: "*Must be at least {{min}} characters",
          maxEmail: "*Must be at most {{max}} characters",
          requiredEmail: "*Email is required",
          requiredReason: "*Please select a reason",
          requiredMessage: "*Please enter your message",
          minMessage: "*Must be at least {{min}} characters",
          maxMessage: "*Must be at most {{max}} characters",
        },
        loading: "Loading...",
        noReasonsAvailable: "No reason available",
        submit: "Submit",
        errors: {
          fetchReasons: "Failed to fetch reasons",
        },
      },

      // Logout Dialog translations
      logout: {
        title: "Are you sure you want to logout?",
        description: "You'll need to sign in again to access your account.",
        button: "Logout",
      },

      // IntroVideoForm translations
      introVideoForm: {
        title: "Intro video",
        description:
          "Brands can see your application video when you apply for a job.",
        uploadPrompt: "Upload your intro video",
        uploading: "Uploading video...",
        saveButton: "Save",
        validation: {
          videoRequired: "*Video is required",
        },
        errors: {
          fileSizeExceeded: "File size exceeds 5MB limit: {{size}}MB",
          invalidFileType:
            "Invalid file type. Please upload an MP4, WebM, OGG, or MOV video",
          processingError: "Error processing video",
          authTokenMissing: "Authentication token missing",
        },
      },

      // Account Form translations
      accountForm: {
        title: "Account Details",
        description:
          "Tell us a little about yourself to personalize your experience.",
        uploadPrompt: "Upload profile picture",
        fields: {
          firstName: "First name",
          lastName: "Last name",
          email: "Email",
          dateOfBirth: "DOB",
        },
        placeholders: {
          firstName: "Enter first name",
          lastName: "Enter last name",
          email: "Enter your email",
          dateOfBirth: "DD/MM/YYYY",
        },
        validation: {
          firstName: {
            required: "*First name is required",
            min: "*Must be at least 3 characters",
            max: "*Must be at most 50 characters",
          },
          lastName: {
            required: "*Last name is required",
            min: "*Must be at least 3 characters",
            max: "*Must be at most 50 characters",
          },
          email: {
            required: "*Email is required",
            invalid: "*Enter a valid email",
            min: "*Must be at least 5 characters",
            max: "*Must be at most 254 characters",
          },
          dateOfBirth: {
            required: "*Date of birth is required",
            future: "*Date cannot be in the future",
          },
        },
        errors: {
          fileSizeExceeded: "File size exceeds 2MB limit: {{size}}MB",
          invalidFileType:
            "Invalid file type. Please upload a JPEG, PNG, or WebP image",
          compressionFailed: "Failed to compress image",
          processingError: "Error processing image",
          authTokenMissing: "Authentication token missing",
          updateFailed: "Failed to update profile details",
        },
        saveButton: "Save",
      },

      // Address Form translations
      addressForm: {
        title: "Address",
        description:
          "Your address for receiving products will only be visible to brands once you are commissioned. It will also appear on your payout receipts.",
        fields: {
          street: "Street, house number",
          postalCode: "Postal code",
          city: "City",
          country: "Country",
        },
        placeholders: {
          street: "Enter Street, house number",
          postalCode: "Enter postcode",
          selectCity: "Select city",
          selectCountry: "Select country",
        },
        validation: {
          street: "*Street and house number are required",
          postalCode: "*Postal code is required",
          city: "*City is required",
          country: "*Country is required",
          invalidCountry: "*Invalid country selection",
        },
        options: {
          noCountryAvailable: "No country available",
          noCityAvailable: "No city available",
        },
        errors: {
          updateFailed: "Failed to update brand details",
        },
        saveButton: "Save",
      },

      // PayoutForm translations
      payoutForm: {
        title: "Payout Details",
        description:
          "Your fee for completed orders will be transferred to you via the IBAN provided.",
        fields: {
          iban: "IBAN",
          vatId: "VAT ID or tax number",
        },
        placeholders: {
          iban: "Enter IBAN number",
          vatId: "Enter VAT ID or Tax number",
        },
        validation: {
          ibanRequired: "*IBAN is required",
          ibanFormat:
            "IBAN should follow the Dutch format: NL + 2 digits + 4 letters + 10 digits",
          vatRequired: "*VAT ID or tax number is required",
          vatFormat:
            "VAT ID should follow the Dutch format: NL + 9 digits + B + 2 digits",
        },
        saveButton: "Save",
      },

      // SocialForm translations
      socialForm: {
        title: "Social accounts",
        description:
          "Brands can see your application video when you apply for a job.",
        fields: {
          instagram: "Instagram",
          tiktok: "Tiktok",
          youtube: "Youtube",
          snapchat: "Snapchat",
          pinterest: "Pinterest",
        },
        placeholders: {
          instagram: "Enter your Instagram link",
          tiktok: "Enter your Tiktok link",
          youtube: "Enter your Youtube link",
          snapchat: "Enter your Snapchat link",
          pinterest: "Enter your Pinterest link",
        },
        validation: {
          validUrl: "*Enter a valid URL",
          instagramRequired: "*Instagram link is required",
          tiktokRequired: "*Tiktok link is required",
          youtubeRequired: "*Youtube link is required",
          snapchatRequired: "*Snapchat link is required",
          pinterestRequired: "*Pinterest link is required",
        },
        saveButton: "Save",
      },

      // CampaignDetailsForm translations
      campaignDetailsForm: {
        steps: {
          title: "Step 01 of 06",
        },
        title: "Describe your campaign details",
        subtitle:
          "Give your campaign a compelling identity. Fill in the details to make it stand out.",
        fields: {
          campaignName: {
            label: "What is the name of the campaign?",
            placeholder: "Write campaign name",
          },
          campaignGoal: {
            label: "What is the goal of the campaign?",
            placeholder: "Select goal of the campaign",
          },
          startDate: {
            label: "Start date",
            placeholder: "DD/MM/YYYY",
          },
          endDate: {
            label: "End date",
            placeholder: "DD/MM/YYYY",
          },
        },
        validation: {
          requiredCampaignName: "*Campaign name is required",
          minCampaignName: "*Must be at least {{min}} characters",
          maxCampaignName: "*Must be at most {{max}} characters",
          requiredCampaignGoal: "*Campaign goal is required",
          requiredStartDate: "*Start date is required",
          pastStartDate: "*Start date cannot be in the past",
          requiredEndDate: "*End date is required",
          invalidEndDate: "*End date must be after the start date",
        },
        buttons: {
          next: "Next",
        },
        errors: {
          createJobError: "Failed to create job",
          updateJobError: "Failed to update job",
        },
      },

      // CampaignTargetForm translations
      campaignTargetForm: {
        steps: "Step {{current}} of {{total}}",
        title: "Your campaign target audience",
        subtitle:
          "Reach the right people! Set preferences to maximize your campaign's impact.",
        fields: {
          ageGroup: "Age group",
          country: "Country/Region",
          city: "City",
          platforms: "Which platforms do you want to focus on?",
        },
        placeholders: {
          ageGroup: "Select age group",
          country: "Select Country/Region",
          city: "Select city",
        },
        validation: {
          requiredAgeGroup: "*Age group is required",
          requiredCountry: "*Country is required",
          invalidCountry: "*Invalid country selection",
          requiredCity: "*City is required",
          invalidCity: "*Invalid city selection",
          minPlatforms: "*Select at least one platform",
        },
        noOptions: {
          country: "No country available",
          city: "No city available",
        },
        errors: {
          jobIdNotFound: "Job ID not found. Please create a job first.",
          submission: "Submission error: {{message}}",
        },
        next: "Next",
      },

      // InfluencerProfileForm translations
      influencerProfileForm: {
        steps: "Step {{current}} of {{total}}",
        title: "Influencer profile",
        subtitle:
          "Showcase your influence and connect with brands. Fill in your details to get started!",
        influencerType: {
          question: "What type of influencers are you looking for?",
          placeholder: "Select influencers type",
          validation: {
            required: "*Influencer type is required",
          },
        },
        niches: {
          question: "Do you have preferred niches/industries?",
          placeholder: "Select niches/industries",
          validation: {
            required: "*At least one niche/industry is required",
          },
        },
        engagementRate: {
          question: "What is the minimum engagement rate you expect?",
          placeholder: "Enter rate in percentage",
          validation: {
            required: "*Engagement rate is required",
            mustBeNumber: "*Must be a number",
            mustBePositive: "*Engagement rate must be positive",
            maxValue: "*Engagement rate cannot exceed 100",
          },
        },
        languages: {
          question: "Do you have language preferences for the influencer?",
          placeholder: "Select languages",
        },
        errors: {
          jobIdNotFound: "Job ID not found. Please create a job first.",
          submission: "Submission error: {{message}}",
          fetchCategories: "Failed to fetch categories",
          fetchLanguages: "Failed to fetch languages",
        },
        next: "Next",
      },

      // CampaignRequirementsForm translations
      campaignRequirementsForm: {
        steps: "Step {{current}} of {{total}}",
        title: "Campaign Requirements",
        subtitle:
          "Define what you're looking for to ensure the perfect fit for your campaign.",
        contentDeadline: "Content deadline",
        deliverables: {
          title: "What specific deliverables do you expect?",
          images: {
            format: "Format",
            ratio: "Ratio",
          },
          videos: {
            format: "Format",
            ratio: "Ratio",
            duration: "Duration",
          },
        },
        brandGuidelines: {
          question: "Are there any brand guidelines or rules to follow?",
          placeholder: "Write in Brief",
        },
        contentApproval: {
          question: "Do you need approval before the content is published?",
          placeholder: "Write in Brief",
        },
        options: {
          yes: "Yes",
          no: "No",
          months: "Months",
          days: "Days",
        },
        validation: {
          requiredMonth: "*Month is required",
          requiredDay: "*Day is required",
          requiredImageFormat: "*Image format is required",
          requiredImageRatio: "*Image ratio is required",
          requiredVideoFormat: "*Video format is required",
          requiredVideoRatio: "*Video ratio is required",
          requiredVideoDuration: "*Video duration is required",
          requiredGuidelinesDetails: "*Guidelines details are required",
          minGuidelinesDetails: "*Must be at least 3 characters",
          maxGuidelinesDetails: "*Must be at most 10000 characters",
          requiredApprovalDetails: "*Approval details are required",
          minApprovalDetails: "*Must be at least 3 characters",
          maxApprovalDetails: "*Must be at most 1000 characters",
          notEmpty: "*Cannot be empty",
        },
        errors: {
          jobIdNotFound: "Job ID not found. Please create a job first.",
          submission: "Submission error: {{message}}",
        },
        next: "Next",
      },

      // CollaborationForm translations
      collaborationForm: {
        steps: "Step {{current}} of {{total}}",
        title: "Barter or Paid collaboration",
        subtitle:
          "Select how you'd like to collaborate with influencers for this campaign.",
        compensationQuestion:
          "Are you offering financial compensation or is this a barter deal?",
        options: {
          barter: "Barter deal",
          financial: "Financial compensation",
        },
        offering: {
          label: "What are you offering?",
          placeholder: "Enter product name",
        },
        estimatedValue: {
          label: "What is its estimated value?",
          placeholder: "€ 00.00",
        },
        validation: {
          requiredCompensation: "*Compensation type is required",
          requiredOffering: "*Offering is required",
          minOffering: "*Must be at least {{min}} characters",
          maxOffering: "*Must be at most {{max}} characters",
          requiredValue: "*Estimated value is required",
          maxValue: "*Must be at most {{max}} digits",
        },
        errors: {
          jobIdNotFound: "Job ID not found. Please create a job first.",
          submission: "Submission error: {{message}}",
        },
        next: "Next",
      },

      // AdditionalDetailsForm translations
      additionalDetailsForm: {
        steps: {
          title: "Step 06 of 06",
        },
        title: "Additional details",
        subtitle:
          "Provide any extra information to ensure a smooth collaboration.",
        fields: {
          references: {
            label:
              "Do you have any references from previous successful campaigns?",
            placeholder: "Write here",
          },
          exclusivePartnership: {
            label:
              "Are you looking for an exclusive partnership with the influencer?",
            placeholder: "Write here",
          },
        },
        validation: {
          requiredReferences: "*References are required",
          minReferences: "*Must be at least {{min}} characters",
          maxReferences: "*Must be at most {{max}} characters",
          requiredPartnership: "*Partnership details are required",
          minPartnership: "*Must be at least {{min}} characters",
          maxPartnership: "*Must be at most {{max}} characters",
        },
        buttons: {
          saveAsDraft: "Save as draft",
          publish: "Publish",
        },
        errors: {
          jobIdNotFound: "Job ID not found. Please create a job first.",
        },
      },

      // AddProductForm translations
      addProductForm: {
        titles: {
          create: "Describe your product",
          edit: "Edit your product",
        },
        description:
          "Help us understand your product better. Provide key details to showcase it effectively.",
        fields: {
          images: "Upload pictures of your product",
          title: "Title",
          productDescription: "Product description",
          productValue: "Product Value",
        },
        placeholders: {
          title: "Enter product name",
          productDescription: "Enter product description",
          productValue: "Enter product value",
        },
        validation: {
          requiredTitle: "*Title is required",
          minTitle: "*Must be at least {{min}} characters",
          maxTitle: "*Must be at most {{max}} characters",
          requiredDescription: "*Product description is required",
          minDescription: "*Must be at least {{min}} characters",
          maxDescription: "*Must be at most {{max}} characters",
          numbersOnly: "*Only numbers are allowed",
          maxDigits: "*Max {{max}} digits allowed",
          requiredImages: "*Images are required",
          minImages: "*At least {{min}} images are required",
          maxImages: "*Maximum {{max}} images allowed",
        },
        buttons: {
          addImage: "Add image",
          save: "Save product",
          update: "Update product",
        },
        labels: {
          optional: "(Optional)",
        },
        messages: {
          waitForUploads: "Please wait for all images to finish uploading",
          failedToLoad: "Failed to load product data",
          failedToUpload: "Failed to upload image",
          fileSizeExceeds: "File size exceeds 2MB limit: {{size}}MB",
          invalidFileType:
            "Invalid file type. Please upload a JPEG, PNG, or WebP image",
          failedToCompress: "Failed to compress image",
        },
      },

      // ApplyJobForm translations
      applyJobForm: {
        placeholders: {
          applicationText: "Write here",
        },
        validation: {
          required: "*Text is required",
          min: "*Must be at least {{min}} characters",
          max: "*Must be at most {{max}} characters",
        },
        buttons: {
          apply: "Apply",
        },
      },

      // Generate Ticket Dialog translations
      generateTicket: {
        title: "Generate ticket",
        fields: {
          reason: "Select reason",
          message: "Message",
        },
        placeholders: {
          reason: "Select your reason",
          message: "Write your message here...",
        },
        validation: {
          requiredReason: "*Please select a reason",
          requiredMessage: "*Please enter your message",
          minMessage: "*Must be at least {{min}} characters",
          maxMessage: "*Must be at most {{max}} characters",
        },
        submit: "Generate",
        reasons: {
          technicalIssue: "Technical Issue",
          billingQuestion: "Billing Question",
          featureRequest: "Feature Request",
          generalInquiry: "General Inquiry",
          other: "Other",
        },
      },

      // Ticket Dialog translations
      ticketDialog: {
        title: "Ticket #{{id}}",
        status: {
          resolved: "Resolved",
          inProgress: "In Progress",
        },
        fields: {
          ticketNumber: "Ticket number",
          reason: "Reason",
          message: "Message",
        },
        messages: {
          resolved:
            "Your ticket has been resolved. Thank you for your patience.",
          inProgressCreator:
            "We're reviewing this ticket and will get back to you soon. If you have any questions? Email us at",
          inProgressBrand:
            "Your ticket is in progress. Our team is working on it and will get back to you soon.",
        },
        email: "mail@gmail.com",
      },

      // Upload Work Dialog translations
      uploadWork: {
        title: "Upload your work",
        uploadButton: "Upload your work",
        submit: "Submit",
        required: "Required:",
        image: "image",
        images: "images",
        video: "video",
        videos: "videos",
        max: "max",
        seconds: "s",
        validation: {
          fileSizeExceeds: "File size exceeds limit",
          invalidFormat: "Invalid file format",
          videoDuration: "Video duration exceeds {{duration}} seconds limit",
          aspectRatio: "{{mediaType}} aspect ratio must be {{ratio}}",
          submitAllFiles:
            "Please submit {{missingItems}} to complete your work submission",
          tooManyFiles: "Too many files uploaded",
          waitForUploads: "Please wait for all files to finish uploading",
          compressionFailed: "Failed to compress file",
          uploadFailed: "Failed to upload file",
          s3TokenFailed: "Failed to get S3 token",
          processingError: "Error processing file",
        },
      },

      // Approve Work Dialog translations
      approveWork: {
        title: "Are you sure you want to approve {{username}}'s work?",
        cancel: "Cancel",
        confirm: "Approve",
      },

      // Revise Work Dialog translations
      reviseWorkDialog: {
        title: "Revise your work?",
        placeholders: {
          message: "Write your message here...",
        },
        validation: {
          requiredMessage: "*Please enter a message",
          minMessage: "*Message must be at least {{min}} characters",
          maxMessage: "*Message cannot exceed {{max}} characters",
        },
        buttons: {
          cancel: "Cancel",
          send: "Send Message",
        },
      },

      // CompleteJob Dialog translations
      completeJob: {
        title: "Are you sure you want to mark this job as completed?",
        cancel: "Cancel",
        confirm: "Yes",
      },

      // Rating/Review Dialog translations
      rating: {
        dialog: {
          title: "Write Review",
          writeReview: "Please write your review here",
          placeholder: "Write here...",
          fields: {
            communication: "Communication",
            timeliness: "Timeliness",
            contentQuality: "Content Quality",
            clarityProfessionalism: "Clarity & professionalism",
          },
          validation: {
            requiredReview: "*Please enter a review",
            minReview: "*Review must be at least {{min}} characters",
            maxReview: "*Review cannot exceed {{max}} characters",
            requiredRating: "*Rating is required",
          },
          submit: "Submit",
        },
        review: {
          title: "All Reviews",
          noReviews: "No reviews available for this user",
          loading: "Loading...",
          noMoreReviews: "No more reviews",
          anonymousUser: "Anonymous User",
          noComment: "No comment provided",
        },
      },

      // DeleteProduct Dialog translations
      deleteProduct: {
        title: "Are you sure you want to delete this product?",
        cancel: "Cancel",
        confirm: "Delete",
      },

      // DeleteJob Dialog translations
      deleteJob: {
        title: "Are you sure you want to delete this job?",
        cancel: "Cancel",
        confirm: "Delete",
      },

      // 404 Page translations
      fourOhFour: {
        pageTitle: "404 | {{appName}}",
        title: "404",
        heading: "Oops! Page Not Found",
        description:
          "The page you are looking for was moved, removed, renamed, or might never have existed!",
        button: "Go to Homepage",
      },
    },
  },
  nl: {
    translation: {
      // Header translations
      header: {
        menuItems: {
          brand: "Merk",
          creator: "Creator",
          pricing: "Prijzen",
          aboutUs: "Over Ons",
        },
        actions: {
          register: "Registreren",
          backToDashboard: "Terug naar Dashboard",
          editProfile: "Profiel Bewerken",
          helpCenter: "Hulpcentrum",
          logout: "Uitloggen",
        },
        creatorActions: {
          appliedJobs: "Toegepaste Opdrachten",
          inProgress: "In Uitvoering",
          myEarnings: "Mijn Inkomsten",
          mySubscription: "Mijn Abonnement",
        },
        brandActions: {
          activeJobs: "Actieve Opdrachten",
          myProduct: "Mijn Product",
          creatorSpotlight: "Creator Spotlight",
          transactionHistory: "Transactiegeschiedenis",
        },
      },

      // Footer translations
      footer: {
        intro:
          "Ontdek het platform dat samenwerkingen tussen bedrijven en content creators gemakkelijk maakt. Begin vandaag en bereik je potentieel met authentieke UGC.",
        sections: {
          navigate: "Navigeren",
          supportUs: "Ondersteuning",
          contactUs: "Contact",
        },
        navigateLinks: {
          home: "Home",
          brand: "Merk",
          creator: "Creator",
          pricing: "Prijzen",
          aboutUs: "Over Ons",
        },
        supportLinks: {
          faqs: "Veelgestelde Vragen",
          supportCenter: "Ondersteuningscentrum",
        },
        contactLinks: {
          email: "collabbarter@.com",
          phone: "+01123 456 7890",
        },
        copyright: "© 2025 Collab Barter, We houden van onze gebruikers!",
        termsConditions: "Algemene Voorwaarden",
        privacyPolicy: "Privacybeleid",
      },

      // Hero Section translations
      heroSection: {
        label: "Influencer Marketing Eenvoudig Gemaakt",
        heading: {
          part1: "Verbinden van",
          part2: "Creativiteit",
          part3: "met",
          part4: "Collab barter",
          part5: ".",
        },
        subtitle:
          "Ontdek het platform dat samenwerkingen tussen bedrijven en content creators gemakkelijk maakt. Begin vandaag en bereik je potentieel met authentieke UGC.",
        ctaButtons: {
          brand: "Word een Merk",
          creator: "Word een Creator",
        },
        stats: {
          creators: "63.000 Creators",
          building: "bouwen samen aan collab barter",
        },
        brandStats: {
          count: "5000+ MERKEN",
        },
        creatorStats: {
          count: "10k+",
          text: "Creator",
        },
      },

      // Teamup Section translations
      teamupSection: {
        heading: {
          part1: "Werk samen",
          part2: "met top",
          part3: "merken",
          part4: "en",
          part5: "bedrijven.",
        },
        brands: {
          thuisbezorgd: "Thuisbezorgd.nl",
          sushito: "Sushito",
          flink: "Flink",
        },
      },

      // Policy Section translations
      policySection: {
        heading: {
          part1: "Moeiteloos",
          part2: "werk,",
          part3: "krachtige",
          part4: "resultaten.",
        },
        subtitle:
          "Het Barter-platform verbindt je met de juiste contentmakers om nieuwe klanten te bereiken, of je nu een restaurant, workshop, bar, merk of kledingwinkel runt.",
        features: [
          {
            title: "Meer dan 5.000 betrouwbare en geverifieerde contentmakers.",
            description:
              "Onze geverifieerde makers bereiken jouw doelgroep met kwalitatieve en impactvolle content.",
          },
          {
            title: "Moeiteloze samenwerking, eenvoudig en snel.",
            description:
              "Eerlijke contentmakers stappen in jouw deal en geven een preview die jouw merk representeert.",
          },
          {
            title: "Zeg vaarwel tegen betalingen en begin met ruilen!",
            description:
              "Ontgrendel het potentieel van je productstrategie en vergroot je eerste bereik als nooit tevoren.",
          },
          {
            title: "Echte en blijvende merkimpact",
            description:
              "Ervaar directe groei via de mensen met wie je samenwerkt. Authentieke UGC.",
          },
        ],
      },

      // Brand Section translations
      brandSection: {
        heading: {
          part1: "Merken: ",
          part2: "5,000+ ",
          part3: "creators staan voor je klaar ",
          part4: "in onze app.",
        },
        description:
          "Ons gebruiksvriendelijke platform laat je UGC maken zonder bureaus of langdurige verplichtingen. Content creators maken verbinding met je via onze app - kies gewoon je favorieten!",
        ctaButton: "Word een Merk",
        cards: {
          firstBrand: "Thuisbezorgd.nl",
          secondBrand: "Sushito",
        },
      },

      // Content Section translations
      contentSection: {
        heading: {
          part1: "Authentieke content op maat gemaakt",
          part2: "speciaal voor jou.",
        },
        subtitle:
          "Het Barter platform verbindt je met de juiste content creators om nieuwe klanten te bereiken, of je nu een restaurant, webshop, bar, merk of kledingwinkel runt.",
      },

      // Subscription Plans translations
      subscriptionPlans: {
        heading: {
          part1: "Inspirerende mogelijkheden en toepassing van",
          part2: "innovatie",
        },
        subtitle: "Begin vandaag. We zijn er klaar voor!",
        popular: "Meest populair",
        chooseButton: "Kies Abonnement",
        plans: [
          {
            price: "15",
            period: "Maandelijks Abonnement",
            features: [
              "Onbeperkt solliciteren op campagnes",
              "Premium badge op profiel",
              "Voorrang in zoekresultaten",
              "Basis prestatieanalyse (weergaven, klikken, likes per campagne)",
              "Vroege toegang tot nieuwe campagnes (48 uur eerder)",
              "Snellere profielgoedkeuring",
            ],
          },
          {
            price: "15",
            period: "Jaarlijks Abonnement",
            features: [
              "Gereduceerde commissie: 10% in plaats van 15%",
              "1x Profiel Spotlight per jaar (profiel uitgelicht gedurende 7 dagen in Verkennen)",
              "Maandelijkse en per-campagne prestatiestatistieken",
              "Prioriteit ondersteuning (directe toegang tot hulpteam)",
              "Bonus Functie: Campagne Favorieten",
            ],
          },
          {
            price: "120",
            period: "Kwartaal Abonnement",
            features: [
              "Onbeperkt solliciteren op campagnes",
              "Premium badge op profiel",
              "Voorrang in zoekresultaten",
              "Basis prestatieanalyse (weergaven, klikken, likes per campagne)",
              "Vroege toegang tot nieuwe campagnes (48 uur eerder)",
              "Snellere profielgoedkeuring",
              "1 exclusieve campagne op uitnodiging per kwartaal",
            ],
          },
        ],
      },

      // Our Mission Section translations
      ourMission: {
        heading: "Wij helpen jouw merk te groeien en bloeien.",
        description:
          "Onze missie is om influencer- en creatormarketing toegankelijk te maken voor bedrijven van alle groottes, wat jouw groei stimuleert. Benut de waarde van je eigen product en elimineer advertentiekosten.",
        ctaButton: "Probeer gratis",
      },

      // Register Type Page translations
      registerType: {
        pageTitle: "Registratie",
        brand: {
          title: "Voor Merken & Bureaus",
          description:
            "Maak bestellingen voor je producten of diensten en laat creators ze voor je promoten.",
          button: "Registreer als Merk of Bureau",
        },
        creator: {
          title: "Voor Creators",
          description:
            "Meld je aan om deel te nemen aan projecten, productcontent te maken en betaald te krijgen.",
          button: "Registreer als Creator",
        },
      },

      // Creator Registration Form translations
      creatorRegister: {
        title: "Creator registratie",
        googleButton: "Doorgaan met Google",
        or: "Of",
        fields: {
          firstName: {
            label: "Voornaam",
            placeholder: "Voer voornaam in",
            error: {
              required: "*Voornaam is verplicht",
              minLength: "*Moet minimaal 3 tekens bevatten",
              maxLength: "*Mag maximaal 50 tekens bevatten",
            },
          },
          lastName: {
            label: "Achternaam",
            placeholder: "Voer achternaam in",
            error: {
              required: "*Achternaam is verplicht",
              minLength: "*Moet minimaal 3 tekens bevatten",
              maxLength: "*Mag maximaal 50 tekens bevatten",
            },
          },
          email: {
            label: "E-mail",
            placeholder: "Voer uw e-mailadres in",
            error: {
              required: "*E-mail is verplicht",
              invalid: "*Voer een geldig e-mailadres in",
              minLength: "*Moet minimaal 5 tekens bevatten",
              maxLength: "*Mag maximaal 254 tekens bevatten",
            },
          },
          dateOfBirth: {
            label: "Geboortedatum",
            placeholder: "DD/MM/JJJJ",
            error: {
              required: "*Geboortedatum is verplicht",
              future: "*Datum kan niet in de toekomst liggen",
            },
          },
        },
        terms: {
          text: "Door een account aan te maken of in te loggen, gaat u akkoord met onze",
          termsLink: "Servicevoorwaarden",
          and: "en",
          privacyLink: "Privacybeleid",
          error: "*U moet de algemene voorwaarden accepteren",
        },
        buttons: {
          signUp: "Aanmelden",
        },
      },

      // Brand Registration Form translations
      brandRegister: {
        title: "Registreer als merk",
        editTitle: "Bewerk uw gegevens",
        description:
          "Bouw uw merkpresentie op. Voer uw gegevens in om te beginnen.",
        editDescription:
          "Werk uw persoonlijke gegevens bij om uw profiel actueel te houden.",
        fields: {
          fullName: {
            label: "Volledige naam",
            placeholder: "Voer volledige naam in",
            error: {
              required: "*Volledige naam is verplicht",
              minLength: "*Moet minimaal 3 tekens bevatten",
              maxLength: "*Mag maximaal 100 tekens bevatten",
            },
          },
          email: {
            label: "E-mail",
            placeholder: "Voer uw e-mailadres in",
            error: {
              required: "*E-mail is verplicht",
              invalid: "*Voer een geldig e-mailadres in",
              minLength: "*Moet minimaal 5 tekens bevatten",
              maxLength: "*Mag maximaal 254 tekens bevatten",
            },
          },
        },
        terms: {
          text: "Ik heb de",
          privacyLink: "gegevensbeschermingsvoorschriften",
          and: "&",
          termsLink: "algemene voorwaarden",
          agree: "gelezen en ga ermee akkoord.",
          error: "*U moet de algemene voorwaarden accepteren",
        },
        buttons: {
          next: "Volgende",
          save: "Opslaan",
        },
      },

      // BrandInfoForm translations in Dutch
      brandForm: {
        title: {
          register: "Registreer als merk",
          edit: "Bewerk je merk",
        },
        subtitle: {
          register:
            "Jouw toegangspoort tot de wereld van creativiteit en samenwerking! Laten we samen duiken in de magie van filmmaking!",
          edit: "Werk je merkinformatie bij om je profiel actueel en nauwkeurig te houden.",
        },
        fields: {
          brandName: {
            label: "Naam van je merk",
            placeholder: "Voer je merknaam in",
          },
          website: {
            label: "Website van je merk",
            placeholder: "www.merkwebsite.com (Optioneel)",
          },
          category: {
            label: "Industrie / categorie",
            placeholder: "Selecteer industrie/categorie",
          },
          taxId: {
            label: "Belasting ID",
            placeholder: "Voer belasting ID in (Optioneel)",
          },
          isAgency: "Mijn bedrijf is een bureau",
        },
        buttons: {
          register: "Aanmelden",
          save: "Opslaan",
        },
        errors: {
          brandNameRequired: "*Merknaam is verplicht",
          brandNameLength: "*Moet tussen 3-100 tekens zijn",
          websiteLength: "*Moet tussen 3-300 tekens zijn",
          categoryRequired: "*Ten minste één industrie/categorie is vereist",
          taxIdLength: "*Moet tussen 4-25 tekens zijn",
        },
      },

      // Verification Form translations
      verification: {
        title: "Verifieer je e-mail",
        sentCode:
          "We hebben een code gestuurd naar {{email}}. Voer het hier in om je account te bevestigen.",
        edit: "BEWERKEN",
        enterOtp: "Voer OTP in",
        notReceived: "OTP niet ontvangen?",
        resend: "Opnieuw verzenden",
        sending: "Versturen...",
        signIn: "Inloggen",
        errors: {
          emailNotFound:
            "E-mail niet gevonden. Ga terug en registreer opnieuw.",
          resendFailed: "OTP opnieuw verzenden mislukt",
          somethingWrong: "Er is iets misgegaan. Probeer het opnieuw.",
          verificationFailed: "Verificatie mislukt. Probeer het opnieuw.",
          otpValidation: "*Voer een geldige 6-cijferige OTP in",
          otpRequired: "*OTP is verplicht",
        },
      },

      // Register Dialog translations
      registerDialog: {
        title: "Hey, Welkom terug!",
        subtitle: "Log in om je reis voort te zetten.",
        continueWithGoogle: "Doorgaan met Google",
        dividerText: "Of",
        emailLabel: "E-mail",
        termsText:
          "Door een account aan te maken of in te loggen, ga je akkoord met onze",
        termsLink: "Servicevoorwaarden",
        andText: "en",
        privacyLink: "Privacybeleid",
        submitButton: "Inloggen",
        errorMessages: {
          emailRequired: "*E-mail is vereist",
          emailValid: "*Voer een geldig e-mailadres in",
          emailMinLength: "*Moet minstens 5 tekens bevatten",
          emailMaxLength: "*Mag maximaal 254 tekens bevatten",
          termsAccepted: "*Je moet de algemene voorwaarden accepteren",
        },
      },

      // Verification Dialog translations
      verificationDialog: {
        title: "Verifieer je e-mail",
        subtitle: "We hebben een verificatiecode gestuurd naar",
        editButton: "BEWERKEN",
        otpLabel: "Voer OTP in",
        notReceivedText: "OTP niet ontvangen?",
        resendButton: "Opnieuw verzenden",
        sendingText: "Verzenden...",
        submitButton: "Inloggen",
        errorMessages: {
          otpRequired: "*OTP is vereist",
          otpValid: "*Voer een geldige 6-cijferige OTP in",
          verificationFailed: "Verificatie mislukt. Probeer het opnieuw.",
          emailNotFound:
            "E-mail niet gevonden. Ga terug en registreer opnieuw.",
          resendFailed: "OTP opnieuw verzenden mislukt",
          defaultError: "Er is iets misgegaan. Probeer het opnieuw.",
        },
      },

      // HelpCenter translations
      helpCenter: {
        title: "Hulpcentrum",
        fields: {
          email: "E-mail",
          reason: "Selecteer reden",
          message: "Bericht",
        },
        placeholders: {
          email: "Voer je e-mailadres in",
          reason: "Selecteer je reden",
          message: "Schrijf hier je bericht...",
        },
        validation: {
          validEmail: "*Voer een geldig e-mailadres in",
          minEmail: "*Moet minimaal {{min}} tekens bevatten",
          maxEmail: "*Mag maximaal {{max}} tekens bevatten",
          requiredEmail: "*E-mail is verplicht",
          requiredReason: "*Selecteer een reden",
          requiredMessage: "*Voer een bericht in",
          minMessage: "*Moet minimaal {{min}} tekens bevatten",
          maxMessage: "*Mag maximaal {{max}} tekens bevatten",
        },
        loading: "Laden...",
        noReasonsAvailable: "Geen reden beschikbaar",
        submit: "Versturen",
        errors: {
          fetchReasons: "Kon redenen niet ophalen",
        },
      },

      // Logout Dialog translations
      logout: {
        title: "Weet je zeker dat je wilt uitloggen?",
        description:
          "Je moet opnieuw inloggen om toegang te krijgen tot je account.",
        button: "Uitloggen",
      },

      // IntroVideoForm translations
      introVideoForm: {
        title: "Introductievideo",
        description:
          "Merken kunnen je video zien wanneer je solliciteert voor een opdracht.",
        uploadPrompt: "Upload je introductievideo",
        uploading: "Video uploaden...",
        saveButton: "Opslaan",
        validation: {
          videoRequired: "*Video is verplicht",
        },
        errors: {
          fileSizeExceeded:
            "Bestandsgrootte overschrijdt de limiet van 5MB: {{size}}MB",
          invalidFileType:
            "Ongeldig bestandstype. Upload een MP4, WebM, OGG of MOV video",
          processingError: "Fout bij het verwerken van video",
          authTokenMissing: "Authenticatietoken ontbreekt",
        },
      },

      // Account Form translations
      accountForm: {
        title: "Accountgegevens",
        description:
          "Vertel ons een beetje over jezelf om je ervaring te personaliseren.",
        uploadPrompt: "Profielfoto uploaden",
        fields: {
          firstName: "Voornaam",
          lastName: "Achternaam",
          email: "E-mail",
          dateOfBirth: "Geboortedatum",
        },
        placeholders: {
          firstName: "Voer voornaam in",
          lastName: "Voer achternaam in",
          email: "Voer e-mail in",
          dateOfBirth: "DD/MM/JJJJ",
        },
        validation: {
          firstName: {
            required: "*Voornaam is verplicht",
            min: "*Moet minimaal 3 tekens bevatten",
            max: "*Mag maximaal 50 tekens bevatten",
          },
          lastName: {
            required: "*Achternaam is verplicht",
            min: "*Moet minimaal 3 tekens bevatten",
            max: "*Mag maximaal 50 tekens bevatten",
          },
          email: {
            required: "*E-mail is verplicht",
            invalid: "*Voer een geldig e-mailadres in",
            min: "*Moet minimaal 5 tekens bevatten",
            max: "*Mag maximaal 254 tekens bevatten",
          },
          dateOfBirth: {
            required: "*Geboortedatum is verplicht",
            future: "*Datum kan niet in de toekomst liggen",
          },
        },
        errors: {
          fileSizeExceeded:
            "Bestandsgrootte overschrijdt de limiet van 2MB: {{size}}MB",
          invalidFileType:
            "Ongeldig bestandstype. Upload een JPEG, PNG of WebP afbeelding",
          compressionFailed: "Kan afbeelding niet comprimeren",
          processingError: "Fout bij het verwerken van afbeelding",
          authTokenMissing: "Authenticatietoken ontbreekt",
          updateFailed: "Kan profielgegevens niet bijwerken",
        },
        saveButton: "Opslaan",
      },

      // Address Form translations
      addressForm: {
        title: "Adres",
        description:
          "Je adres voor het ontvangen van producten is alleen zichtbaar voor merken nadat je bent ingehuurd. Het zal ook verschijnen op je betalingsbonnen.",
        fields: {
          street: "Straat, huisnummer",
          postalCode: "Postcode",
          city: "Stad",
          country: "Land",
        },
        placeholders: {
          street: "Voer straat en huisnummer in",
          postalCode: "Voer postcode in",
          selectCity: "Selecteer stad",
          selectCountry: "Selecteer land",
        },
        validation: {
          street: "*Straat en huisnummer zijn verplicht",
          postalCode: "*Postcode is verplicht",
          city: "*Stad is verplicht",
          country: "*Land is verplicht",
          invalidCountry: "*Ongeldige landkeuze",
        },
        options: {
          noCountryAvailable: "Geen land beschikbaar",
          noCityAvailable: "Geen stad beschikbaar",
        },
        errors: {
          updateFailed: "Kan merkgegevens niet bijwerken",
        },
        saveButton: "Opslaan",
      },

      // PayoutForm translations
      payoutForm: {
        title: "Uitbetalingsgegevens",
        description:
          "Uw vergoeding voor voltooide bestellingen wordt overgemaakt via de opgegeven IBAN.",
        fields: {
          iban: "IBAN",
          vatId: "BTW-nummer of fiscaal nummer",
        },
        placeholders: {
          iban: "Voer IBAN-nummer in",
          vatId: "Voer BTW-ID of fiscaal nummer in",
        },
        validation: {
          ibanRequired: "*IBAN is verplicht",
          ibanFormat:
            "IBAN moet het Nederlandse formaat volgen: NL + 2 cijfers + 4 letters + 10 cijfers",
          vatRequired: "*BTW-ID of fiscaal nummer is verplicht",
          vatFormat:
            "BTW-ID moet het Nederlandse formaat volgen: NL + 9 cijfers + B + 2 cijfers",
        },
        saveButton: "Opslaan",
      },

      // SocialForm translations
      socialForm: {
        title: "Sociale accounts",
        description:
          "Merken kunnen je applicatievideo zien wanneer je solliciteert voor een opdracht.",
        fields: {
          instagram: "Instagram",
          tiktok: "Tiktok",
          youtube: "Youtube",
          snapchat: "Snapchat",
          pinterest: "Pinterest",
        },
        placeholders: {
          instagram: "Voer je Instagram-link in",
          tiktok: "Voer je Tiktok-link in",
          youtube: "Voer je Youtube-link in",
          snapchat: "Voer je Snapchat-link in",
          pinterest: "Voer je Pinterest-link in",
        },
        validation: {
          validUrl: "*Voer een geldige URL in",
          instagramRequired: "*Instagram-link is verplicht",
          tiktokRequired: "*Tiktok-link is verplicht",
          youtubeRequired: "*Youtube-link is verplicht",
          snapchatRequired: "*Snapchat-link is verplicht",
          pinterestRequired: "*Pinterest-link is verplicht",
        },
        saveButton: "Opslaan",
      },

      // CampaignDetailsForm translations
      campaignDetailsForm: {
        steps: {
          title: "Stap 01 van 06",
        },
        title: "Beschrijf je campagnedetails",
        subtitle:
          "Geef je campagne een overtuigende identiteit. Vul de details in om het te laten opvallen.",
        fields: {
          campaignName: {
            label: "Wat is de naam van de campagne?",
            placeholder: "Schrijf campagnenaam",
          },
          campaignGoal: {
            label: "Wat is het doel van de campagne?",
            placeholder: "Selecteer doel van de campagne",
          },
          startDate: {
            label: "Startdatum",
            placeholder: "DD/MM/JJJJ",
          },
          endDate: {
            label: "Einddatum",
            placeholder: "DD/MM/JJJJ",
          },
        },
        validation: {
          requiredCampaignName: "*Campagnenaam is verplicht",
          minCampaignName: "*Moet minimaal {{min}} tekens bevatten",
          maxCampaignName: "*Mag maximaal {{max}} tekens bevatten",
          requiredCampaignGoal: "*Campagnedoel is verplicht",
          requiredStartDate: "*Startdatum is verplicht",
          pastStartDate: "*Startdatum kan niet in het verleden liggen",
          requiredEndDate: "*Einddatum is verplicht",
          invalidEndDate: "*Einddatum moet na de startdatum liggen",
        },
        buttons: {
          next: "Volgende",
        },
        errors: {
          createJobError: "Kon job niet aanmaken",
          updateJobError: "Kon job niet bijwerken",
        },
      },

      // CampaignTargetForm translations
      campaignTargetForm: {
        steps: "Stap {{current}} van {{total}}",
        title: "Je campagne doelgroep",
        subtitle:
          "Bereik de juiste mensen! Stel voorkeuren in om de impact van je campagne te maximaliseren.",
        fields: {
          ageGroup: "Leeftijdsgroep",
          country: "Land/Regio",
          city: "Stad",
          platforms: "Op welke platforms wil je je richten?",
        },
        placeholders: {
          ageGroup: "Selecteer leeftijdsgroep",
          country: "Selecteer Land/Regio",
          city: "Selecteer stad",
        },
        validation: {
          requiredAgeGroup: "*Leeftijdsgroep is vereist",
          requiredCountry: "*Land is vereist",
          invalidCountry: "*Ongeldige landselectie",
          requiredCity: "*Stad is vereist",
          invalidCity: "*Ongeldige stadselectie",
          minPlatforms: "*Selecteer ten minste één platform",
        },
        noOptions: {
          country: "Geen land beschikbaar",
          city: "Geen stad beschikbaar",
        },
        errors: {
          jobIdNotFound:
            "Opdracht-ID niet gevonden. Maak eerst een opdracht aan.",
          submission: "Fout bij indienen: {{message}}",
        },
        next: "Volgende",
      },

      // InfluencerProfileForm translations (Dutch)
      influencerProfileForm: {
        steps: "Stap {{current}} van {{total}}",
        title: "Influencerprofiel",
        subtitle:
          "Toon je invloed en kom in contact met merken. Vul je gegevens in om te beginnen!",
        influencerType: {
          question: "Naar welk type influencers ben je op zoek?",
          placeholder: "Selecteer type influencer",
          validation: {
            required: "*Influencertype is verplicht",
          },
        },
        niches: {
          question: "Heb je voorkeuren voor niches/sectoren?",
          placeholder: "Selecteer niches/sectoren",
          validation: {
            required: "*Minstens één niche/sector is verplicht",
          },
        },
        engagementRate: {
          question: "Wat is het minimale engagementpercentage dat je verwacht?",
          placeholder: "Voer percentage in",
          validation: {
            required: "*Engagementpercentage is verplicht",
            mustBeNumber: "*Moet een getal zijn",
            mustBePositive: "*Engagementpercentage moet positief zijn",
            maxValue: "*Engagementpercentage mag niet hoger zijn dan 100",
          },
        },
        languages: {
          question: "Heb je voorkeur voor talen van de influencer?",
          placeholder: "Selecteer talen",
        },
        errors: {
          jobIdNotFound:
            "Vacature-ID niet gevonden. Maak eerst een vacature aan.",
          submission: "Fout bij indienen: {{message}}",
          fetchCategories: "Ophalen van categorieën mislukt",
          fetchLanguages: "Ophalen van talen mislukt",
        },
        next: "Volgende",
      },

      // CampaignRequirementsForm translations
      campaignRequirementsForm: {
        steps: "Stap {{current}} van {{total}}",
        title: "Campagne Vereisten",
        subtitle:
          "Definieer waar je naar op zoek bent om de perfecte match voor je campagne te garanderen.",
        contentDeadline: "Content deadline",
        deliverables: {
          title: "Welke specifieke resultaten verwacht je?",
          images: {
            format: "Formaat",
            ratio: "Verhouding",
          },
          videos: {
            format: "Formaat",
            ratio: "Verhouding",
            duration: "Duur",
          },
        },
        brandGuidelines: {
          question: "Zijn er merkrichtlijnen of regels om te volgen?",
          placeholder: "Kort beschrijven",
        },
        contentApproval: {
          question:
            "Heb je goedkeuring nodig voordat de content wordt gepubliceerd?",
          placeholder: "Kort beschrijven",
        },
        options: {
          yes: "Ja",
          no: "Nee",
          months: "Maanden",
          days: "Dagen",
        },
        validation: {
          requiredMonth: "*Maand is verplicht",
          requiredDay: "*Dag is verplicht",
          requiredImageFormat: "*Afbeeldingsformaat is verplicht",
          requiredImageRatio: "*Afbeeldingsverhouding is verplicht",
          requiredVideoFormat: "*Videoformaat is verplicht",
          requiredVideoRatio: "*Videoverhouding is verplicht",
          requiredVideoDuration: "*Videoduur is verplicht",
          requiredGuidelinesDetails: "*Richtlijndetails zijn verplicht",
          minGuidelinesDetails: "*Moet minimaal 3 tekens bevatten",
          maxGuidelinesDetails: "*Mag maximaal 10000 tekens bevatten",
          requiredApprovalDetails: "*Goedkeuringsdetails zijn verplicht",
          minApprovalDetails: "*Moet minimaal 3 tekens bevatten",
          maxApprovalDetails: "*Mag maximaal 1000 tekens bevatten",
          notEmpty: "*Mag niet leeg zijn",
        },
        errors: {
          jobIdNotFound:
            "Opdracht-ID niet gevonden. Maak eerst een opdracht aan.",
          submission: "Fout bij indienen: {{message}}",
        },
        next: "Volgende",
      },

      // CollaborationForm translations
      collaborationForm: {
        steps: "Stap {{current}} van {{total}}",
        title: "Ruil- of betaalde samenwerking",
        subtitle:
          "Selecteer hoe je wilt samenwerken met influencers voor deze campagne.",
        compensationQuestion:
          "Bied je financiële compensatie of is dit een ruilovereenkomst?",
        options: {
          barter: "Ruilovereenkomst",
          financial: "Financiële compensatie",
        },
        offering: {
          label: "Wat bied je aan?",
          placeholder: "Voer productnaam in",
        },
        estimatedValue: {
          label: "Wat is de geschatte waarde?",
          placeholder: "€ 00.00",
        },
        validation: {
          requiredCompensation: "*Compensatietype is vereist",
          requiredOffering: "*Aanbieding is vereist",
          minOffering: "*Moet ten minste {{min}} tekens bevatten",
          maxOffering: "*Mag maximaal {{max}} tekens bevatten",
          requiredValue: "*Geschatte waarde is vereist",
          maxValue: "*Mag maximaal {{max}} cijfers bevatten",
        },
        errors: {
          jobIdNotFound:
            "Opdracht-ID niet gevonden. Maak eerst een opdracht aan.",
          submission: "Fout bij indienen: {{message}}",
        },
        next: "Volgende",
      },

      // AdditionalDetailsForm translations
      additionalDetailsForm: {
        steps: {
          title: "Stap 06 van 06",
        },
        title: "Aanvullende details",
        subtitle:
          "Geef extra informatie om een soepele samenwerking te garanderen.",
        fields: {
          references: {
            label: "Heb je referenties van eerdere succesvolle campagnes?",
            placeholder: "Schrijf hier",
          },
          exclusivePartnership: {
            label: "Zoek je een exclusieve samenwerking met de influencer?",
            placeholder: "Schrijf hier",
          },
        },
        validation: {
          requiredReferences: "*Referenties zijn verplicht",
          minReferences: "*Moet minimaal {{min}} tekens bevatten",
          maxReferences: "*Mag maximaal {{max}} tekens bevatten",
          requiredPartnership: "*Details over partnerschap zijn verplicht",
          minPartnership: "*Moet minimaal {{min}} tekens bevatten",
          maxPartnership: "*Mag maximaal {{max}} tekens bevatten",
        },
        buttons: {
          saveAsDraft: "Opslaan als concept",
          publish: "Publiceren",
        },
        errors: {
          jobIdNotFound: "Job ID niet gevonden. Maak eerst een job aan.",
        },
      },

      // AddProductForm translations
      addProductForm: {
        titles: {
          create: "Beschrijf je product",
          edit: "Bewerk je product",
        },
        description:
          "Help ons je product beter te begrijpen. Geef belangrijke details om het effectief te presenteren.",
        fields: {
          images: "Upload afbeeldingen van je product",
          title: "Titel",
          productDescription: "Productbeschrijving",
          productValue: "Productwaarde",
        },
        placeholders: {
          title: "Voer productnaam in",
          productDescription: "Voer productbeschrijving in",
          productValue: "Voer productwaarde in",
        },
        validation: {
          requiredTitle: "*Titel is verplicht",
          minTitle: "*Moet minimaal {{min}} karakters bevatten",
          maxTitle: "*Mag maximaal {{max}} karakters bevatten",
          requiredDescription: "*Productbeschrijving is verplicht",
          minDescription: "*Moet minimaal {{min}} karakters bevatten",
          maxDescription: "*Mag maximaal {{max}} karakters bevatten",
          numbersOnly: "*Alleen cijfers zijn toegestaan",
          maxDigits: "*Maximaal {{max}} cijfers toegestaan",
          requiredImages: "*Afbeeldingen zijn verplicht",
          minImages: "*Minimaal {{min}} afbeeldingen vereist",
          maxImages: "*Maximaal {{max}} afbeeldingen toegestaan",
        },
        buttons: {
          addImage: "Afbeelding toevoegen",
          save: "Product opslaan",
          update: "Product bijwerken",
        },
        labels: {
          optional: "(Optioneel)",
        },
        messages: {
          waitForUploads: "Wacht tot alle afbeeldingen zijn geüpload",
          failedToLoad: "Productgegevens laden mislukt",
          failedToUpload: "Afbeelding uploaden mislukt",
          fileSizeExceeds:
            "Bestandsgrootte overschrijdt limiet van 2MB: {{size}}MB",
          invalidFileType:
            "Ongeldig bestandstype. Upload een JPEG, PNG of WebP afbeelding",
          failedToCompress: "Afbeelding comprimeren mislukt",
        },
      },

      // ApplyJobForm translations
      applyJobForm: {
        placeholders: {
          applicationText: "Schrijf hier",
        },
        validation: {
          required: "*Tekst is verplicht",
          min: "*Moet minimaal {{min}} karakters bevatten",
          max: "*Mag maximaal {{max}} karakters bevatten",
        },
        buttons: {
          apply: "Solliciteren",
        },
      },

      // Generate Ticket Dialog translations
      generateTicket: {
        title: "Ticket genereren",
        fields: {
          reason: "Selecteer reden",
          message: "Bericht",
        },
        placeholders: {
          reason: "Selecteer je reden",
          message: "Schrijf hier je bericht...",
        },
        validation: {
          requiredReason: "*Selecteer een reden",
          requiredMessage: "*Voer je bericht in",
          minMessage: "*Moet minimaal {{min}} tekens bevatten",
          maxMessage: "*Mag maximaal {{max}} tekens bevatten",
        },
        submit: "Genereren",
        reasons: {
          technicalIssue: "Technisch Probleem",
          billingQuestion: "Facturatievraag",
          featureRequest: "Verzoek voor Functie",
          generalInquiry: "Algemene Vraag",
          other: "Anders",
        },
      },

      // Ticket Dialog translations
      ticketDialog: {
        title: "Ticket #{{id}}",
        status: {
          resolved: "Opgelost",
          inProgress: "In Behandeling",
        },
        fields: {
          ticketNumber: "Ticketnummer",
          reason: "Reden",
          message: "Bericht",
        },
        messages: {
          resolved: "Je ticket is opgelost. Bedankt voor je geduld.",
          inProgressCreator:
            "We bekijken dit ticket en komen binnenkort bij je terug. Heb je vragen? Mail ons op",
          inProgressBrand:
            "Je ticket is in behandeling. Ons team werkt eraan en neemt binnenkort contact met je op.",
        },
        email: "mail@gmail.com",
      },

      // Upload Work Dialog translations
      uploadWork: {
        title: "Upload je werk",
        uploadButton: "Upload je werk",
        submit: "Indienen",
        required: "Vereist:",
        image: "afbeelding",
        images: "afbeeldingen",
        video: "video",
        videos: "video's",
        max: "max",
        seconds: "s",
        validation: {
          fileSizeExceeds: "Bestandsgrootte overschrijdt limiet",
          invalidFormat: "Ongeldig bestandsformaat",
          videoDuration: "Videoduur overschrijdt {{duration}} seconden limiet",
          aspectRatio: "{{mediaType}} beeldverhouding moet {{ratio}} zijn",
          submitAllFiles:
            "Dien {{missingItems}} in om je werkinzending te voltooien",
          tooManyFiles: "Te veel bestanden geüpload",
          waitForUploads: "Wacht tot alle bestanden klaar zijn met uploaden",
          compressionFailed: "Kan bestand niet comprimeren",
          uploadFailed: "Kan bestand niet uploaden",
          s3TokenFailed: "Kan geen S3-token krijgen",
          processingError: "Fout bij het verwerken van bestand",
        },
      },

      // Approve Work Dialog translations
      approveWork: {
        title:
          "Weet je zeker dat je het werk van {{username}} wilt goedkeuren?",
        cancel: "Annuleren",
        confirm: "Goedkeuren",
      },

      // Revise Work Dialog translations
      reviseWorkDialog: {
        title: "Je werk herzien?",
        placeholders: {
          message: "Schrijf hier je bericht...",
        },
        validation: {
          requiredMessage: "*Voer een bericht in",
          minMessage: "*Bericht moet minimaal {{min}} tekens bevatten",
          maxMessage: "*Bericht mag niet meer dan {{max}} tekens bevatten",
        },
        buttons: {
          cancel: "Annuleren",
          send: "Bericht verzenden",
        },
      },

      // CompleteJob Dialog translations
      completeJob: {
        title: "Weet je zeker dat je deze opdracht als voltooid wilt markeren?",
        cancel: "Annuleren",
        confirm: "Ja",
      },

      // Rating/Review Dialog translations
      rating: {
        dialog: {
          title: "Schrijf een Beoordeling",
          writeReview: "Schrijf hier je beoordeling",
          placeholder: "Schrijf hier...",
          fields: {
            communication: "Communicatie",
            timeliness: "Tijdigheid",
            contentQuality: "Inhoudskwaliteit",
            clarityProfessionalism: "Duidelijkheid & professionaliteit",
          },
          validation: {
            requiredReview: "*Voer een beoordeling in",
            minReview: "*Beoordeling moet minimaal {{min}} tekens bevatten",
            maxReview: "*Beoordeling mag niet meer dan {{max}} tekens bevatten",
            requiredRating: "*Beoordeling is verplicht",
          },
          submit: "Versturen",
        },
        review: {
          title: "Alle Beoordelingen",
          noReviews: "Geen beoordelingen beschikbaar voor deze gebruiker",
          loading: "Laden...",
          noMoreReviews: "Geen beoordelingen meer",
          anonymousUser: "Anonieme Gebruiker",
          noComment: "Geen commentaar gegeven",
        },
      },

      // DeleteProduct Dialog translations
      deleteProduct: {
        title: "Weet je zeker dat je dit product wilt verwijderen?",
        cancel: "Annuleren",
        confirm: "Verwijderen",
      },

      // DeleteJob Dialog translations
      deleteJob: {
        title: "Weet je zeker dat je deze opdracht wilt verwijderen?",
        cancel: "Annuleren",
        confirm: "Verwijderen",
      },

      // 404 Page translations
      fourOhFour: {
        pageTitle: "404 | {{appName}}",
        title: "404",
        heading: "Oeps! Pagina Niet Gevonden",
        description:
          "De pagina die je zoekt is verplaatst, verwijderd, hernoemd of heeft mogelijk nooit bestaan!",
        button: "Ga naar Startpagina",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
